export const states = [
  { stateName: 'states.all', stateId: '0' },
  { stateName: 'states.central', stateId: '99' },
  { stateName: 'states.andamanNicobarIslands', stateId: '32' },
  { stateName: 'states.andhraPradesh', stateId: '17' },
  { stateName: 'states.arunachalPradesh', stateId: '23' },
  { stateName: 'states.assam', stateId: '4' },
  { stateName: 'states.bihar', stateId: '29' },
  { stateName: 'states.chandigarh', stateId: '3' },
  { stateName: 'states.chhattisgarh', stateId: '9' },
  { stateName: 'states.dadraNagarHaveliANDdamanDiu', stateId: '5' },
  // { stateName: 'states.damanDiu', stateId: '13' },
  { stateName: 'states.delhi', stateId: '30' },
  { stateName: 'states.goa', stateId: '18' },
  { stateName: 'states.gujarat', stateId: '10' },
  { stateName: 'states.haryana', stateId: '20' },
  { stateName: 'states.himachalPradesh', stateId: '8' },
  { stateName: 'states.jammuKashmir', stateId: '33' },
  { stateName: 'states.jharkhand', stateId: '34' },
  { stateName: 'states.karnataka', stateId: '28' },
  { stateName: 'states.kerala', stateId: '25' },
  { stateName: 'states.ladakh', stateId: '38' },
  { stateName: 'states.lakshadweep', stateId: '21' },
  { stateName: 'states.madhyaPradesh', stateId: '22' },
  { stateName: 'states.manipur', stateId: '24' },
  { stateName: 'states.maharashtra', stateId: '2' },
  { stateName: 'states.meghalaya', stateId: '16' },
  { stateName: 'states.mizoram', stateId: '7' },
  { stateName: 'states.nagaland', stateId: '11' },
  { stateName: 'states.odisha', stateId: '1' },
  { stateName: 'states.punjab', stateId: '31' },
  { stateName: 'states.puducherry', stateId: '12' },
  { stateName: 'states.rajasthan', stateId: '37' },
  { stateName: 'states.sikkim', stateId: '27' },
  { stateName: 'states.tamilNadu', stateId: '19' },
  { stateName: 'states.telangana', stateId: '36' },
  { stateName: 'states.tripura', stateId: '14' },
  { stateName: 'states.uttarakhand', stateId: '15' },
  { stateName: 'states.uttarPradesh', stateId: '35' },
  { stateName: 'states.westBengal', stateId: '26' },
];
